import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.8335 16.6663V63.333C8.8335 65.174 10.3259 66.6663 12.1668 66.6663H23.8335H30.5002L25.5002 48.333L37.1668 44.9997L35.5002 33.333L48.8335 26.6663L45.5002 21.6663L50.5002 13.333H12.1668C10.3259 13.333 8.8335 14.8254 8.8335 16.6663Z",
      stroke: "#3C3C43",
      "stroke-opacity": "0.33",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M72.1665 63.333V16.6663C72.1665 14.8254 70.6742 13.333 68.8332 13.333H63.8332L57.1665 23.333L62.1665 31.6663L47.1665 38.333L48.8332 51.6663L37.1665 54.9997L40.4998 66.6663H68.8332C70.6742 66.6663 72.1665 65.174 72.1665 63.333Z",
      stroke: "#3C3C43",
      "stroke-opacity": "0.33",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.6665 30C26.0472 30 27.1665 28.8807 27.1665 27.5C27.1665 26.1193 26.0472 25 24.6665 25C23.2858 25 22.1665 26.1193 22.1665 27.5C22.1665 28.8807 23.2858 30 24.6665 30Z",
      stroke: "#3C3C43",
      "stroke-opacity": "0.33",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }